/* eslint-disable prefer-destructuring */
/* eslint-disable no-undef */
/* eslint-disable no-undef */
/**
 *
 * @author qiezi
 * @update 2014.12.09
 */

import $ from 'jquery';
import qs from 'qs';
import '../css/guanwang/guanwang.scss';
import pkg from '../../package.json';

const isMobile = /(iPhone|iPad|iPod|Android)/i.test(navigator.userAgent);
const win = window;
const $win = $(win);
const topOps = {
    aboutMe: $('#J_AboutMe').offset().top,
    introPro: $('#J_IntroPro').offset().top,
    joinUs: $('#J_JoinUs').offset().top,
    welfare: $('#J_Welfare').offset().top,
    contactUs: $('#J_ContactUs').offset().top
};
const animateOps = {
    aboutMe: true,
    introPro: true,
    joinUs: true,
    welfare: true,
    contactUs: true
};
let $overlayHtml;

const homeCtrl = {
    init() {
        const self = this;

        // 动画效果
        self.Animate('#J_BannerTextAnimate_d', 'bounceInUp');
        self.Animate('#J_BannerTextAnimate_a', 'bounceInDown', 600);
        self.Animate('#J_BannerTextAnimate_c', 'zoomIn', 1200);


        // 职位鼠标滑过效果
        $('.J_Jobs').hover(function () {
            $(this).addClass('jobs-item-hover');
        }, function () {
            $(this).removeClass('jobs-item-hover');
        });

        // 统计点击量
        $('#J_BannerTextAnimate_c').on('click', () => {
            self.trace('_trackPageview', '/details/clicks');
        });

        // 动画效果
        // self.animateAll();
        // $win.scroll(function(){
        //     self.animateAll();
        // });

        // 定位到相应模块
        $('.J_PositionMod').on('click', function (e) {
            e.preventDefault();
            const $li = $(this).closest('li');
            const i = $li.index();
            let top;

            $li.siblings('.current').removeClass('current').end().addClass('current');

            switch (i) {
            case 0: top = 0;
                break;
            case 1: top = topOps.aboutMe;
                break;
            case 2: top = topOps.introPro;
                break;
            case 3: top = topOps.joinUs;
                break;
            case 4: top = topOps.contactUs;
                break;
            default:
            }

            $('html, body').animate({
                scrollTop: top
            }, 500);
        });

        // 根字体大小
        self.rootFontSizeReset();
        win.onresize = function () {
            self.rootFontSizeReset();
        };

        // 职位弹窗
        // $('.J_Jobs').on('click', function () {
        //     const i = $(this).index();
        //     const $dialogJobs = $('.dialog-jobs');

        //     $dialogJobs.hide().eq(i)
        //         .css({ top: `-${$dialogJobs.height()}px` })
        //         .show()
        //         .stop()
        //         .animate({
        //             top: '50%'
        //         }, 500);

        //     self.overlay.show();
        // });

        // // 关闭弹窗
        // $('.J_DialogJobsClose').on('click', function () {
        //     $(this).closest('.dialog-jobs').hide();
        //     self.overlay.close();
        // });
    },
    overlay: {
        first: 1,
        show() {
            if (this.first) {
                $overlayHtml = $('<div class="overlay"></div>');
                $overlayHtml.appendTo('body').css({
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: '#000',
                    opacity: '.6',
                    zIndex: 98
                }).on('click', () => {
                    $('.J_DialogJobsClose').click();
                });
                $(document).on('keydown', (e) => {
                    if (e.keyCode === 27) {
                        $('.J_DialogJobsClose').click();
                    }
                });
                this.first = 0;
            }
            $overlayHtml.show();
        },
        close() {
            $overlayHtml.hide();
        }
    },
    rootFontSizeReset() {
        const winW = $(win).width();
        $('html').css({
            fontSize: winW > 640 ? '40px' : `${(winW / 640) * 40}px`
        });
    },
    Animate(e, type, t) {
        t = t || 0;
        setTimeout(() => {
            $(e).addClass(`${type} animated`).removeClass('hide')
                .one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function () {
                    $(this).removeClass(`${type}animated`);
                });
        }, t);
    },
    animateAboutMe() {
        $('.J_AnamateAboutMeLeft').each(function (i) {
            const t = i * 500;
            homeCtrl.Animate($(this), 'fadeInLeft', t);
        });

        $('.J_AnamateAboutMeRight').each(function (i) {
            const t = (i * 250) + 1000;
            homeCtrl.Animate($(this), 'fadeInRight', t);
        });
    },
    animateIntroPro() {
        $('.J_AnamateIntroProLeft').each(function (i) {
            const t = i * 500;
            homeCtrl.Animate($(this), 'fadeInLeft', t);
        });
    },
    animateJoinUs() {
        $('.J_AnamateJoinUsLeft').each(function (i) {
            const t = i * 500;
            homeCtrl.Animate($(this), 'fadeInLeft', t);
        });

        $('.J_AnamateJoinUsRight').each(function (i) {
            const t = (i * 500) + 500;
            homeCtrl.Animate($(this), 'fadeInRight', t);
        });
    },
    animateWelfare() {
        homeCtrl.Animate('.J_AnamateJoinUsRote', 'rotateIn');
        $('.J_AnamateJoinUsBounce').each(function (i) {
            const t = i * 500;
            homeCtrl.Animate($(this), 'bounceIn', t);
        });

        $('.J_AnamateJoinUsRight').each(function (i) {
            const t = i * 500;
            homeCtrl.Animate($(this), 'fadeInRight', t);
        });
    },
    animateAll() {
        const winTop = $win.scrollTop() + $win.height() + 200;

        if (animateOps.aboutMe && topOps.aboutMe < winTop && topOps.introPro > winTop) {
            this.animateAboutMe();
            animateOps.aboutMe = false;
        }

        if (animateOps.introPro && topOps.introPro < winTop && topOps.joinUs > winTop) {
            this.animateIntroPro();
            animateOps.introPro = false;
        }

        if (animateOps.joinUs && topOps.joinUs < winTop && topOps.welfare > winTop) {
            this.animateJoinUs();
            animateOps.joinUs = false;
        }

        if (animateOps.welfare && topOps.welfare < winTop && topOps.contactUs > winTop) {
            this.animateWelfare();
            animateOps.welfare = false;
        }
    },
    trace() {
        /* eslint-disable */
        const slice = Array.prototype.slice;
        const _hmt = window._hmt || [];
        const args = slice.call(arguments);
        _hmt.push(args);
        /* eslint-enable */
    }
};

const mobileCtrl = {
    init() {
        const self = this;

        // 删除职位hover
        $('.jobs-human').removeClass('show-hover-bg');

        // 动画效果
        self.Animate('#J_BannerTextAnimate_d', 'bounceInUp');
        self.Animate('#J_BannerTextAnimate_a', 'bounceInDown', 600);
        self.Animate('#J_BannerTextAnimate_c', 'zoomIn', 1200);

        // 动画效果
        // self.animateAll();
        // $win.scroll(function(){
        //     self.animateAll();
        // });


        // 根字体大小
        self.rootFontSizeReset();
        win.onresize = function () {
            self.rootFontSizeReset();
        };

        $('.J_Jobs').on('click', function () {
            const i = $(this).index();
            $('.dialog-jobs').eq(i).show();
            $('.dialog-mobile-jobs-close-wrap').show();
        });

        $('.J_DialogMobileJobsClose').on('click', () => {
            $('.dialog-jobs').hide();
            $('.dialog-mobile-jobs-close-wrap').hide();
        });

        // 显示首屏文字
        const firstHeight = $('#J_BannerTextAnimate_a span').offset().top;
        const firstTopHeight = $('#J_BannerTextAnimate_a').offset().top;

        if ($win.height() < firstHeight) {
            $('html,body').scrollTop(firstTopHeight);
        }
    },
    rootFontSizeReset() {
        const winW = $(win).width();
        $('html').css({
            fontSize: winW > 640 ? '40px' : `${(winW / 640) * 40}px`
        });
    },
    Animate(e, type, t) {
        t = t || 0;
        setTimeout(() => {
            $(e).addClass(`${type} animated`).removeClass('hide').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function () {
                $(this).removeClass(`${type}animated`);
            });
        }, t);
    },
    animateAboutMe() {
        $('.J_AnamateAboutMeLeft').each(function (i) {
            const t = i * 500;
            homeCtrl.Animate($(this), 'fadeInLeft', t);
        });

        $('.J_AnamateAboutMeRight').each(function (i) {
            const t = (i * 250) + 1000;
            homeCtrl.Animate($(this), 'fadeInRight', t);
        });
    },
    animateIntroPro() {
        $('.J_AnamateIntroProLeft').each(function (i) {
            const t = i * 500;
            homeCtrl.Animate($(this), 'fadeInLeft', t);
        });
    },
    animateJoinUs() {
        $('.J_AnamateJoinUsLeft').each(function (i) {
            const t = i * 500;
            homeCtrl.Animate($(this), 'fadeInLeft', t);
        });

        $('.J_AnamateJoinUsRight').each(function (i) {
            const t = (i * 500) + 500;
            homeCtrl.Animate($(this), 'fadeInRight', t);
        });
    },
    animateWelfare() {
        homeCtrl.Animate('.J_AnamateJoinUsRote', 'rotateIn');
        $('.J_AnamateJoinUsBounce').each(function (i) {
            const t = i * 500;
            homeCtrl.Animate($(this), 'bounceIn', t);
        });

        $('.J_AnamateJoinUsRight').each(function (i) {
            const t = i * 500;
            homeCtrl.Animate($(this), 'fadeInRight', t);
        });
    },
    animateAll() {
        const winTop = $win.scrollTop() + $win.height() + 200;

        if (animateOps.aboutMe && topOps.aboutMe < winTop && topOps.introPro > winTop) {
            this.animateAboutMe();
            animateOps.aboutMe = false;
        }

        if (animateOps.introPro && topOps.introPro < winTop && topOps.joinUs > winTop) {
            this.animateIntroPro();
            animateOps.introPro = false;
        }

        if (animateOps.joinUs && topOps.joinUs < winTop && topOps.welfare > winTop) {
            this.animateJoinUs();
            animateOps.joinUs = false;
        }

        if (animateOps.welfare && topOps.welfare < winTop && topOps.contactUs > winTop) {
            this.animateWelfare();
            animateOps.welfare = false;
        }
    }
};

// eslint-disable-next-line prefer-destructuring
const trackerWind = gdTracker.trackerWind;
const showLog = window.sessionStorage.getItem('__tracker_log') || /__tracker_log/.test(window.location.href);
if (showLog) window.sessionStorage.setItem('__tracker_log', true);

const { host } = window.location;
let env = 'dev';
if (/[\w\.-]+huanleguang.com/.test(host)) {
    env = 'prod';
}

trackerWind.setup({
    project: 'huanleguang', // 项目名
    version: pkg.version, // 项目版本
    env, // 项目环境，一般有 3 种, `dev`、`stage`、`prod`。
    showLog, // 输出上报信息，建议仅在开发时开启。
    transport: showLog ? 'image' : '',
});

// UTM 追踪插件
// eslint-disable-next-line no-undef
trackerWind.use('utmDataTracker', gdTracker.UtmDataTracker, {
    inVue: false
});

const { location } = window;
const fullPath = location.host + location.pathname + location.hash;
const query = qs.parse(location.search.replace('?', ''));
const params = qs.parse(location.hash.replace(/^[\w#\/]+\??/, ''));
trackerWind.trackPageView({
    page: fullPath, // 域名 + 路径（类似于 vue 路由） 'www.huanleguang.com'
    page_params: {
        ...query,
        ...params
    }
});

if (isMobile) {
    mobileCtrl.init();
} else {
    homeCtrl.init();
}

export default homeCtrl;
